<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  count: number
  disabled?: boolean
}>()

const emit = defineEmits<{
  cancel: []
  forward: []
}>()

const countLabel = computed(() => {
  const n = props.count
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) {
    return `${n} сообщение`
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${n} сообщения`
  }
  return `${n} сообщений`
})
</script>

<template>
  <div class="message-selection-bar">
    <VBtn
      variant="text"
      color="default"
      :disabled="disabled"
      @click="emit('cancel')"
    >
      Отмена
    </VBtn>

    <span class="message-selection-bar__count">
      Выбрано: {{ countLabel }}
    </span>

    <VBtn
      color="primary"
      :disabled="disabled || count === 0"
      @click="emit('forward')"
    >
      Переслать
      <VIcon
        end
        icon="ri-share-forward-line"
      />
    </VBtn>
  </div>
</template>

<style scoped lang="scss">
.message-selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  background: rgb(var(--v-theme-surface));
}

.message-selection-bar__count {
  flex: 1;
  text-align: center;
  font-size: 0.875rem;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}
</style>
